import React from 'react';
import styled from 'styled-components';

const PartnerButtonWrapper = styled.a`
    display:inline-block;
    color:#ffff;
    background:#0083C6;
    cursor: pointer;
    padding: 5px;
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    align-items: center;
    text-align: center;
    padding: 13px;
    width:220px;
    text-decoration:none;
`;


export const PartnerButton = () => {

    return(
        <PartnerButtonWrapper href='mailto:partners@weatherbug.com'>
            Join WeatherBug Partners
        </PartnerButtonWrapper>
    );
};